<template>
  <div class="tab-bar">
    <ul>
      <li
        v-for="tab in tabs"
        :class="{active: active === tabs.indexOf(tab)}"
        :key="tabs.indexOf(tab)"
        @click="active = tabs.indexOf(tab)">
        {{tab}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  props: ['tabs'],
  data() {
    return {
      active: 0,
    };
  },
  watch: {
    active(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  ul
    display: flex
    justify-content: center
    list-style: none
    margin: 0 1rem
    padding: 0

  li
    display: flex
    align-items: center
    justify-content: center
    box-sizing: border-box
    margin: 0 2px
    padding: 1rem 2rem
    height: 92px
    width: 340px
    font-size: 2.4rem
    font-weight: 700
    background-color: $green60
    color: $white
    user-select: none
    cursor: pointer
    &.active
      background-color: $green30
      color: $green

    @media only screen and (max-width: 700px)
      font-size: 2rem
      text-align: center

</style>
